// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { readerId, type ReaderId } from './Reader';
import { algorithm, type default as Algorithm } from './Algorithm';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.antenna */
export type AntennaId = string & { __brand: 'public.antenna' };

/** Represents the table public.antenna */
export default interface AntennaTable {
  id: ColumnType<AntennaId, AntennaId | undefined, AntennaId>;

  internal_id: ColumnType<string, string, string>;

  reader_id: ColumnType<ReaderId, ReaderId, ReaderId>;

  name: ColumnType<string, string | undefined, string>;

  order: ColumnType<number | null, number | null, number | null>;

  data: ColumnType<string | null, string | null, string | null>;

  rssi_worst: ColumnType<number | null, number | null, number | null>;

  rssi_best: ColumnType<number | null, number | null, number | null>;

  rssi_worst_min_reads: ColumnType<number | null, number | null, number | null>;

  rssi_best_min_reads: ColumnType<number | null, number | null, number | null>;

  tag_ttl: ColumnType<number | null, number | null, number | null>;

  algorithm: ColumnType<Algorithm, Algorithm | undefined, Algorithm>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type Antenna = Selectable<AntennaTable>;

export type NewAntenna = Insertable<AntennaTable>;

export type AntennaUpdate = Updateable<AntennaTable>;

export const antennaId = z.string() as unknown as z.Schema<AntennaId>;

export const antenna = z.object({
  id: antennaId,
  internal_id: z.string(),
  reader_id: readerId,
  name: z.string(),
  order: z.number().nullable(),
  data: z.string().nullable(),
  rssi_worst: z.number().nullable(),
  rssi_best: z.number().nullable(),
  rssi_worst_min_reads: z.number().nullable(),
  rssi_best_min_reads: z.number().nullable(),
  tag_ttl: z.number().nullable(),
  algorithm: algorithm,
  _created_at: z.string(),
}) as unknown as z.Schema<Antenna>;

export const antennaInitializer = z.object({
  id: antennaId.optional(),
  internal_id: z.string(),
  reader_id: readerId,
  name: z.string().optional(),
  order: z.number().optional().nullable(),
  data: z.string().optional().nullable(),
  rssi_worst: z.number().optional().nullable(),
  rssi_best: z.number().optional().nullable(),
  rssi_worst_min_reads: z.number().optional().nullable(),
  rssi_best_min_reads: z.number().optional().nullable(),
  tag_ttl: z.number().optional().nullable(),
  algorithm: algorithm.optional(),
}) as unknown as z.Schema<AntennaInitializer>;

export const antennaMutator = z.object({
  id: antennaId.optional(),
  internal_id: z.string().optional(),
  reader_id: readerId.optional(),
  name: z.string().optional(),
  order: z.number().optional().nullable(),
  data: z.string().optional().nullable(),
  rssi_worst: z.number().optional().nullable(),
  rssi_best: z.number().optional().nullable(),
  rssi_worst_min_reads: z.number().optional().nullable(),
  rssi_best_min_reads: z.number().optional().nullable(),
  tag_ttl: z.number().optional().nullable(),
  algorithm: algorithm.optional(),
}) as unknown as z.Schema<AntennaMutator>;
